/**
 * Pushes a GTM dataLayer event on every successful WPForms submission.
 *
 * WPForms triggers "wpformsAjaxSubmitSuccess" as a jQuery event on the
 * <form> element, so it can only be caught via jQuery — not
 * addEventListener. The form title comes from the `data-form-title`
 * attribute added in inc/vendor/wpforms/form_hooks.php.
 */
(() => {
  function bind($) {
    $(document).on("wpformsAjaxSubmitSuccess", ".wpforms-form", function () {
      const $form = $(this);

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "wpforms_submit",
        form_id: $form.data("formid") || "",
        form_title: $form.data("form-title") || "",
      });
    });
  }

  if (window.jQuery) {
    bind(window.jQuery);
  } else {
    document.addEventListener("DOMContentLoaded", () => {
      if (window.jQuery) bind(window.jQuery);
    });
  }
})();
